@if (panelHeader) {
  <!-- Composite form that references a form panel -->
  <!-- Needs to be the same as lm-richtext.component.html displayAsText -->
  @if (panelHeaderRichTextVars) {
    <div
      class="editor-container is-preview field panel-header-text">
      <h2
        class="lm-richtext-content is-preview hide-white-space input-full"
        data-options="{preview: true}"
        [innerHTML]="panelHeader | formatMessageRule:true:panelHeader:panelData:specFields"
        soho-editor
      ></h2>
    </div>
  }
  @if (!panelHeaderRichTextVars) {
    <h2 class="panel-header-text">{{panelHeader | formatMessageRule:true:panelHeader:panelData:specFields}}</h2>
  }
}

@if (panelText) {
  <!-- Composite form that references a form, list, multilist panel -->
  <!-- Needs to be the same as lm-richtext.component.html displayAsText -->
  @if (panelTextRichTextVars) {
    <div
      [ngClass]="panelClass"
      class="editor-container is-preview field">
      <h4
        class="lm-richtext-content is-preview hide-white-space input-full"
        data-options="{preview: true}"
        [innerHTML]="panelText | formatMessageRule:true:panelText:panelData:specFields"
        soho-editor
      ></h4>
    </div>
  }
  @if (!panelTextRichTextVars) {
    <h4 [ngClass]="panelClass">{{panelText | formatMessageRule:true:panelText:panelData:specFields}}</h4>
  }
}
